import React from "react";
import { Grid } from "material-ui";
import { Card } from "@material-ui/core";
import { CardHeader } from "material-ui";
import Tooltip from "material-ui/Tooltip";
import { IconButton } from "material-ui";
import { FiInfo } from "react-icons/fi";
import { CardContent } from "material-ui";
import { assets } from "../../../assets";
import { AvoidedCO2ConvertedCar } from "./AvoidedCO2ConvertedCar";
import { AvoidedCO2ConvertedHome } from "./AvoidedCO2ConvertedHome";
import { AvoidedCO2ConvertedNuclearWaste } from "./AvoidedCO2ConvertedNuclearWaste";
import { AvoidedCO2ConvertedTree } from "./AvoidedCO2ConvertedTree";
import { AvoidedCO2ConvertedWorldTour } from "./AvoidedCO2ConvertedWorldTour";
import Slider from "react-slick";
import { enums } from "../../../enums/index";

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000
};

export class ConvertedAvoidedCO2Card extends React.Component {

  render() {
    const { 
      classes, 
      t, 
      infoButtonHandler,
      avoidedCO2GramsYTD,
      energyMatchedInWhYTD,
      loading,
      co2Equivalents,
      user
    } = this.props;

    let CO2Equivalent_co2_for_1km_driven_in_g=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.CO2_FOR_1KM_DRIVEN_IN_G);
    let CO2Equivalent_co2_for_1km_travelled_in_g=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.CO2_FOR_1KM_TRAVALLED_IN_G);
    let CO2Equivalent_world_tour_distance_in_km=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.WORLD_TOUR_DISTANCE_IN_KM);
    let CO2Equivalent_average_household_electricity_consumption_in_kwh=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.AVERAGE_HOUSEHOLD_ELECTRICITY_CONSUMPTION_IN_KWH);
    let CO2Equivalent_nuclear_waste_for_1mwh_nuclear_electricity_in_g=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.NUCLEAR_WASTE_FOR_1MWH_NUCLEAR_ELECTRICITY_IN_G);
    let CO2Equivalent_co2_per_tree_seedings_in_t=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.CO2_PER_TREE_SEEDING_IN_T);

    return (
      <Grid item xs={12} sm={3}>
        <Card className={classes.card} style={{ minHeight: 224 }}>
          <CardHeader
            action={
              <Tooltip title={t("Co2 details")}>
                <IconButton
                  className={classes.button}
                  onClick={() => infoButtonHandler()}
                >
                  <FiInfo
                    style={{
                      color: "rgba(0, 0, 0, 0.54)",
                      fontSize: 16
                    }}
                  />
                </IconButton>
              </Tooltip>
            }
            avatar={<img src={assets.icons.readIcon} style={{ maxHeight: 20 }} alt=""/>}
            title={t("Yearly CO2 equivalent")}
            style={{ paddingBottom: 10, paddingTop: 6 }}
          />
          <CardContent style={{ paddingTop: 0 }}>
            <Slider {...sliderSettings}>
              {CO2Equivalent_co2_for_1km_driven_in_g && 
                <div><AvoidedCO2ConvertedCar t={t} classes={classes}
                avoidedCO2Grams={avoidedCO2GramsYTD}
                loading={loading}
                user={user}
                co2_for_1km_driven_in_g={CO2Equivalent_co2_for_1km_driven_in_g.co2EquivalentValue}
              ></AvoidedCO2ConvertedCar></div>
            }
            {CO2Equivalent_co2_for_1km_travelled_in_g && CO2Equivalent_world_tour_distance_in_km && 
              <div><AvoidedCO2ConvertedWorldTour t={t} classes={classes}
              avoidedCO2Grams={avoidedCO2GramsYTD}
              loading={loading}
              co2_for_1km_travelled_in_g={CO2Equivalent_co2_for_1km_travelled_in_g.co2EquivalentValue}
              world_tour_distance_in_km={CO2Equivalent_world_tour_distance_in_km.co2EquivalentValue}
            ></AvoidedCO2ConvertedWorldTour></div>
            }
            {CO2Equivalent_average_household_electricity_consumption_in_kwh &&
              <div><AvoidedCO2ConvertedHome t={t} classes={classes}
              energyInWh={energyMatchedInWhYTD}
              loading={loading}
              average_household_electricity_consumption_in_kwh={CO2Equivalent_average_household_electricity_consumption_in_kwh.co2EquivalentValue}
            ></AvoidedCO2ConvertedHome></div>
            }
            {CO2Equivalent_nuclear_waste_for_1mwh_nuclear_electricity_in_g &&
              <div><AvoidedCO2ConvertedNuclearWaste user={user} t={t} classes={classes}
              energyInWh={energyMatchedInWhYTD}
              loading={loading}
              nuclear_waste_for_1mwh_nuclear_electricity_in_g={CO2Equivalent_nuclear_waste_for_1mwh_nuclear_electricity_in_g.co2EquivalentValue}
            ></AvoidedCO2ConvertedNuclearWaste></div>
            }
            {CO2Equivalent_co2_per_tree_seedings_in_t &&
              <div><AvoidedCO2ConvertedTree t={t} classes={classes}
              avoidedCO2Grams={avoidedCO2GramsYTD}
              loading={loading}
              co2_per_tree_seedings_in_t={CO2Equivalent_co2_per_tree_seedings_in_t.co2EquivalentValue}
            ></AvoidedCO2ConvertedTree></div>
            }
            </Slider>
          </CardContent>
        </Card>
      </Grid>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/ConvertedAvoidedCO2/ConvertedAvoidedCO2Card.js